import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import SlideListFetching from "./SlideListFetching";
import NotFoundV2 from "../NotFound/NotFoundV2";
import { NotificationManager } from "react-notifications";
import _ from "i18n";
import {
  deleteSlide,
  duplicateSlide,
  fetchAvailableSlide,
  updatePrivacySlide,
  updateStateSlide,
  setSlidePrivate,
  useSharedSlide
} from "Thunks";
import { setSlideSelectedItem, setSlideIsEditable } from "Actions";
import SlideItem from "./SlideItem";
import { ModalConfirm } from "tamtam-components";

class SlideList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      visible: false,
      slide: 1,
      SlideId: null,
      isOpenModal: false,
      isOpenModalDelete: false,
      isOpenModalPrivacy: false,
      isOpenModalState: false,
      id: null,
      errorAlert: false,
      uen: "",
      isOpenModalPrivatize: false,
      isOpenModalUsingSharedSlide: false
    };
    this.setSelectedSlideId = this.setSelectedSlideId.bind(this);
    this.carousel = React.createRef();
  }

  handleDuplicateSlide = id => {
    this.setState({ isOpenModal: true });
    this.setState({ id: id });
  };

  handleSharedSlide = (id, isEditable) => {
    this.setState({ isOpenModalPrivacy: true });
    this.setState({ id: id });
    this.props.dispatch(setSlideIsEditable(isEditable));
  };

  handleSetSlidePrivate = id => {
    this.setState({ isOpenModalPrivatize: true });
    this.setState({ id: id });
  };

  handleChangeStateSlide = (id, uen) => {
    this.setState({ isOpenModalState: true });
    this.setState({ id: id, uen: uen });
  };

  handleUseSharedSlide = (id, uen) => {
    this.setState({ isOpenModalUsingSharedSlide: true });
    this.setState({ id: id, uen: uen });
  };

  onFailure(err) {
    this.setState({
      errorAlert: true,
      isOpenModalDelete: false,
      isOpenModalPrivatize: false
    });
    if (err.response.data.errors[0].code === 1700124) {
      NotificationManager.error(_("slideAlreadyUsedDeleteError"), _("error"));
    } else if (err.response.data.errors[0].code === 1700122) {
      NotificationManager.error(_("slideAlreadyUsed"), _("error"));
    } else {
      NotificationManager.error(
        err.response.data.errors
          ? err.response.data.errors[0].message
          : _("incompleteOperation"),
        _("error")
      );
    }
  }
  handleDeleteSlide = id => {
    this.setState({ isOpenModalDelete: true });
    this.setState({ id: id });
  };
  onSuccess(res, msg) {
    if (msg === "shared") {
      NotificationManager.success(_("slideShared"), _("slideSharedSuccess"));
    }
    if (msg === "deleted") {
      NotificationManager.success(_("slideDeleted"), _("slideDeletedSuccess"));
    }
    if (msg === "add") {
      NotificationManager.success(_("slideAdded"), _("addSlideSuccess"));
    }
    if (msg === "privatize") {
      NotificationManager.success(
        _("titleVisibilitySlide"),
        _("slidePrivateSuccess")
      );
    }
  }

  setSelectedSlideId(slideId) {
    this.setState({
      slideId: slideId
    });
  }

  handleSelectSlide = id => {
    let { selectedSlide } = this.props;

    let newSelectedSlides = [...selectedSlide];
    if (newSelectedSlides.includes(id)) {
      newSelectedSlides.splice(newSelectedSlides.indexOf(id), 1);
    } else {
      newSelectedSlides.push(id);
    }
    this.props.dispatch(setSlideSelectedItem(newSelectedSlides));
  };

  handleDisplayUpdateSlide = slide => {
    this.props.dispatch(push(`/composition/slide/${slide.id}`));
  };

  onChangeIsEditable = () => {
    const {
      dispatch,
      composition: { isEditable }
    } = this.props;
    dispatch(setSlideIsEditable(isEditable ? 0 : 1));
  };

  render() {
    // let { slides } = this.props;
    const {
      selectedSlide,
      slides,
      dispatch,
      fetching,
      saving,
      saved,
      allowUpdateSlide,
      filterValue,
      newTag,
      closeNewTag,
      composition: { isEditable }
    } = this.props;

    let {
      isOpenModal,
      isOpenModalDelete,
      id,
      isOpenModalPrivacy,
      isOpenModalState,
      uen,
      isOpenModalPrivatize,
      isOpenModalUsingSharedSlide
    } = this.state;
    // if ((fetching || saving) && !errorAlert) {
    //   return <SlideListFetching />;
    // }
    return (
      <div className="row medium-12">
        {saved || slides.length ? (
          slides.map((item, i) => {
            return (
              <SlideItem
                key={`slide-${item.slides.id}`}
                slide={item.slides}
                {...item.slides}
                allowUpdateSlide={allowUpdateSlide}
                globalState={item.globalState}
                selected={selectedSlide.includes(item.slides.id)}
                handleSelectSlide={this.handleSelectSlide}
                handleDisplayUpdateSlide={this.handleDisplayUpdateSlide}
                deleteSlide={this.handleDeleteSlide}
                duplicateSlide={this.handleDuplicateSlide}
                sharedSlide={this.handleSharedSlide}
                handleSetSlidePrivate={this.handleSetSlidePrivate}
                changeStateSlide={this.handleChangeStateSlide}
                handleUseSharedSlide={this.handleUseSharedSlide}
                filterValue={filterValue}
                newTag={newTag}
                closeNewTag={closeNewTag}
              />
              // <SlideItem slide={item} {...item} key={i} />
            );
          })
        ) : (
          <NotFoundV2 />
        )}
        <ModalConfirm
          type={"duplicate"}
          isOpen={isOpenModal}
          onCancel={() => this.setState({ isOpenModal: false })}
          onConfirm={() => {
            dispatch(duplicateSlide(id)).then(
              res => {
                this.props.dispatch(push(`/slides`));
                NotificationManager.success(
                  _("slideDuplicated"),
                  _("duplicateSlideSuccess")
                );
              },
              err => {
                this.onFailure(err);
              }
            );
          }}
          inProcess={false}
          actionFailed={false}
          title={_("titleDuplicateSlide")}
          text={_("duplicateSlideContent")}
          labelNo={_("cancel")}
          labelYes={_("duplicate")}
          labelError={"Error"}
        />
        <ModalConfirm
          type={"delete"}
          isOpen={isOpenModalDelete}
          onCancel={() => this.setState({ isOpenModalDelete: false })}
          onConfirm={() => {
            dispatch(deleteSlide(id)).then(
              res => {
                this.onSuccess(res, "deleted");
                dispatch(fetchAvailableSlide());
                this.setState({ isOpenModalDelete: false, errorAlert: false });
              },
              err => this.onFailure(err)
            );
          }}
          inProcess={false}
          actionFailed={false}
          title={_("deleteConfirm")}
          text={_("deleteSlideConfirmContent")}
          labelNo={_("cancel")}
          labelYes={_("delete")}
          labelError={"Error"}
        />
        <ModalConfirm
          type={"share"}
          isOpen={isOpenModalPrivacy}
          isChecked={isEditable}
          onCancel={() => this.setState({ isOpenModalPrivacy: false })}
          onConfirm={() => {
            dispatch(updatePrivacySlide(id, isEditable)).then(
              res => {
                this.onSuccess(res, "shared");
                dispatch(fetchAvailableSlide());
                this.setState({ isOpenModalPrivacy: false, errorAlert: false });
              },
              err => this.onFailure(err)
            );
          }}
          onSwitch={() => this.onChangeIsEditable()}
          inProcess={false}
          actionFailed={false}
          title={_("titleSharedSlide")}
          text={_("sharedSlideContent")}
          secondText={_("editableTemplate")}
          labelNo={_("cancel")}
          labelYes={_("share")}
          labelError={"Error"}
        />
        <ModalConfirm
          type={"privatize"}
          isOpen={isOpenModalPrivatize}
          onCancel={() => this.setState({ isOpenModalPrivatize: false })}
          onConfirm={() => {
            dispatch(setSlidePrivate(id)).then(
              res => {
                this.onSuccess(res, "privatize");
                dispatch(fetchAvailableSlide());
                this.setState({
                  isOpenModalPrivatize: false,
                  errorAlert: false
                });
              },
              err => this.onFailure(err)
            );
          }}
          inProcess={false}
          actionFailed={false}
          title={_("titleVisibilitySlide")}
          text={_("visibilitySlideContent")}
          labelNo={_("no")}
          labelYes={_("yes")}
          labelError={"Error"}
        />
        <ModalConfirm
          type={"add"}
          isOpen={isOpenModalState}
          onCancel={() => this.setState({ isOpenModalState: false })}
          onConfirm={() => {
            dispatch(updateStateSlide(id, uen)).then(
              res => {
                this.onSuccess(res, "add");
                dispatch(fetchAvailableSlide());
                this.setState({ isOpenModalState: false, errorAlert: false });
              },
              err => this.onFailure(err)
            );
          }}
          inProcess={false}
          actionFailed={false}
          title={_("titleAddSlide")}
          text={_("addSlideContent")}
          labelNo={_("cancel")}
          labelYes={_("add")}
          labelError={"Error"}
        />
        <ModalConfirm
          type={"add"}
          isOpen={isOpenModalUsingSharedSlide}
          onCancel={() => this.setState({ isOpenModalUsingSharedSlide: false })}
          onConfirm={() => {
            dispatch(useSharedSlide(id, uen)).then(
              res => {
                this.onSuccess(res, "add");
                dispatch(fetchAvailableSlide());
                this.setState({
                  isOpenModalUsingSharedSlide: false,
                  errorAlert: false
                });
              },
              err => this.onFailure(err)
            );
          }}
          inProcess={false}
          actionFailed={false}
          title={_("titleUseSharedSlide")}
          text={_("useSharedSlideContent")}
          labelNo={_("cancel")}
          labelYes={_("use")}
          labelError={"Error"}
        />
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  fetching: state.slideList.fetching,
  saving: state.slideList.saving,
  saved: state.slideList.saved,
  // slides: state.slideList.items,
  composition: state.slideComposition.composition,
  selectedSlide: state.slideList.selected
});

export default connect(mapStateToProps)(SlideList);



// WEBPACK FOOTER //
// ./src/components/SlideList/SlideList.js